import tw from 'tailwind-styled-components'

export const HeaderContainer = tw.div`
h-full
`

export const TitleNotifications = tw.span`
text-lg
font-semibold
text-blueTheme
`

export const Top = tw.div`
flex-wrap
flex 
justify-between 
px-12
pt-8
items-center
`
export const TopInputs = tw.div`
flex 
flex-wrap
gap-4
`

export const FilterContainer = tw.div`
md:flex 
flex-row
items-end 
md:justify-between 
px-8 
mt-6
`

export const  StatusNotifications = tw.p`
text-sm 
text-darkGray/80 
md:mt-0 
mt-5
`
